export default __webpack_public_path__ + "static/media/ghost.4bbf2e8e.png";